import { Children, cloneElement, Fragment, useState, useEffect } from "react";
import cntl from "cntl";

function Steps({ children, hasLabel, currentActive }) {
  const [activeStep, setActiveStep] = useState(currentActive);

  const stepperLineCn = (isStepVisited) => cntl`
        w-0.5 
        h-20
        ${isStepVisited ? cntl`border border-primary-600` : cntl`bg-grey-300`}
        ${hasLabel ? cntl`ml-24` : null}
    `;

  useEffect(() => {
    setActiveStep(currentActive);
  }, [currentActive]);

  return (
    <div className="flex flex-col flex-wrap items-center">
      {children &&
        Children.map(children, (child, index) => {
          const isStepVisited = index <= activeStep;
          const isLastStep = index === children.length - 1;
          return (
            <Fragment key={`stepper-child-${index}`}>
              {cloneElement(child, {
                activeStep,
                currentStep: index,
                isLastStep,
              })}
              {index < children.length - 1 && (
                <div className={stepperLineCn(isStepVisited)} />
              )}
            </Fragment>
          );
        })}
    </div>
  );
}

export default Steps;
